import { Systems } from "@/fhir/enums/systems";

export const POSITIVE_DISPLAY = "Positive";
export const NEGATIVE_DISPLAY = "Negative";

export const positiveNegativeRadioOptions = [
  { label: POSITIVE_DISPLAY, value: POSITIVE_DISPLAY },
  { label: NEGATIVE_DISPLAY, value: NEGATIVE_DISPLAY },
] as const;

export type PositiveNegativeRadioOption = (typeof positiveNegativeRadioOptions)[number];

export function positiveNegativeDisplayToCoding(display: string | null | undefined) {
  if (display === POSITIVE_DISPLAY) {
    return {
      system: Systems.QH,
      code: "positive",
      display: POSITIVE_DISPLAY,
    };
  }
  if (display === NEGATIVE_DISPLAY) {
    return {
      system: Systems.QH,
      code: "negative",
      display: NEGATIVE_DISPLAY,
    };
  }
  return undefined;
}

export function codingToPositiveNegativeDisplay(
  code: string | undefined,
  display?: string,
): PositiveNegativeRadioOption["value"] | null {
  if (code === "positive" || display === POSITIVE_DISPLAY) {
    return POSITIVE_DISPLAY;
  }
  if (code === "negative" || display === NEGATIVE_DISPLAY) {
    return NEGATIVE_DISPLAY;
  }
  return null;
}

/** Reads Positive/Negative display from a questionnaire answer. */
export function readPositiveNegativeDisplayFromAnswer(
  answer:
    | {
        valueCoding?: { code?: string; display?: string };
        valueString?: string;
      }
    | undefined,
): PositiveNegativeRadioOption["value"] | null {
  if (!answer) {
    return null;
  }

  const coding = answer.valueCoding;
  if (coding) {
    const fromCoding = codingToPositiveNegativeDisplay(coding.code, coding.display);
    if (fromCoding) {
      return fromCoding;
    }
  }

  if (answer.valueString === POSITIVE_DISPLAY || answer.valueString === NEGATIVE_DISPLAY) {
    return answer.valueString;
  }

  return null;
}
